async function getFacilities (options) {
    return this.api({
        url: `/facility`,
        method: 'GET',
        params: { ...options }
    })
}

async function getFacilitiesCreate () {
    return this.api({
        url: `/facility/create`,
        method: 'GET'
    })
}

async function getFacilitiesEdit () {
    return this.api({
        url: `/facility/edit`,
        method: 'GET'
    })
}

async function addFacility (options) {
    const fields = ['acronym', 'type', 'owner']
    const data = Object.fromEntries(Object.entries(options).filter(([f, v]) => v != null && fields.includes(f)))

    return this.api({
        url: `/facility/`,
        method: 'POST',
        data: data
    })
}

async function getOwnFacility () {
    return this.api({
        url: `/facility/own`,
        method: 'GET'
    })
}

async function getFacility (facilityId) {
    return this.api({
        url: `/facility/${facilityId}`,
        method: 'GET'
    })
}

async function getFacilityEdit (facilityId) {
    return this.api({
        url: `/facility/${facilityId}/edit`,
        method: 'GET'
    })
}

async function editFacility (facilityId, options) {
    return this.api({
        url: `/facility/${facilityId}`,
        method: 'PATCH',
        data: Object.fromEntries(Object.entries(options).filter(([f, v]) => v != null && f != null))
    })
}

async function invite (facilityId) {
    return this.api({
        url: `/facility/${facilityId}/invite`,
        method: 'PUT'
    })
}

async function getFacilityInstruments (facilityId) {
    return this.api({
        url: `/cars/facility/${facilityId}/instruments`,
        method: 'GET'
    })
}

async function getDisplayableStatuses () {
    return this.api({
        url: `/types/facility/displayed-status`
    })
}

async function getInitialAcceptance (facilityId) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}`
    })
}

async function patchInitialAcceptance (facilityId, options) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}`,
        method: 'PATCH',
        data: options
    })
}

async function getIaSubmissionAllowed (facilityId) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}/submission-allowed`,
        method: 'GET'
    })
}

async function submitApplication (facilityId) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}`,
        method: 'POST'
    })
}

async function getCARSAcceptanceTypes () {
    return this.api({url: `/cars/types/acceptance`})
}

async function getCARSComplianceTypes () {
    return this.api({url: `/cars/types/compliance`})
}

async function saveCARSAcceptance (facilityId, acceptance) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}`,
        method: 'PATCH',
        data: {
            acceptance: acceptance
        }
    })
}

async function submitCARSFinalAcceptance (facilityId, acceptance) {
    return this.api({
        url: `/cars/facility/${facilityId}/initial-acceptance`,
        method: 'PATCH',
        data: {
            acceptance: acceptance
        }
    })
}

async function submitCARSPreliminaryAcceptance (facilityId, acceptance) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}`,
        method: 'PATCH',
        data: {
            preliminary_acceptance: acceptance
        }
    })
}

async function getCARSFacilitySynergyComplianceEdit(facilityId) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}/synergy-compliance/edit`,
        method: 'GET'
    })
}

async function getCARSFacilityLidarComplianceEdit(facilityId) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}/lidar-compliance/edit`,
        method: 'GET'
    })
}

async function getCARSFacilityPhotometerComplianceEdit(facilityId) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}/photometer-compliance/edit`,
        method: 'GET'
    })
}

async function getCARSFacilitySynergyCompliance(facilityId) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}/synergy-compliance`,
        method: 'GET'
    })
}

async function editCARSFacilitySynergyCompliance(facilityId, options) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}/synergy-compliance`,
        method: 'PATCH',
        data: options
    })
}

async function submitCARSFacilitySynergyCompliance(facilityId, options) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}/synergy-compliance`,
        method: 'PUT',
        data: options
    })
}

async function getCARSSynergyMatrix (facilityId) {
    return this.api({url: `/cars/initial-acceptance/facility/${facilityId}/synergy-compliance/matrix`})
}

async function rebuildPreliminaryReport (facilityId) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}/preliminary-report`,
        method: 'DELETE'
    })
}

async function rebuildFinalReport (facilityId) {
    return this.api({
        url: `/cars/initial-acceptance/facility/${facilityId}/final-report`,
        method: 'DELETE'
    })
}

export default {
    pluginName: 'facilities',
    methods: {
        getFacilities, getFacilitiesCreate, getFacilitiesEdit,
        addFacility,
        getOwnFacility,
        getFacility, getFacilityEdit, editFacility,
        invite,
        getFacilityInstruments,
        getDisplayableStatuses,
        getCARSAcceptanceTypes, getCARSComplianceTypes,
        getInitialAcceptance, patchInitialAcceptance, submitApplication, getIaSubmissionAllowed,
        saveCARSAcceptance, submitCARSFinalAcceptance, submitCARSPreliminaryAcceptance,
        getCARSFacilitySynergyComplianceEdit, getCARSFacilityLidarComplianceEdit, getCARSFacilityPhotometerComplianceEdit,
        getCARSFacilitySynergyCompliance, editCARSFacilitySynergyCompliance, submitCARSFacilitySynergyCompliance,
        getCARSSynergyMatrix,
        rebuildPreliminaryReport, rebuildFinalReport
    }
}